<div *ngIf="show" class="modal-dialog" [attr.role]="'document'">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm"
				[attr.data-dismiss]="'modal'" type="button" (click)="close();">Chiudi</button>
		</p>
		<div class="titleblock">
			<h3 class="title1level">Attenzione:</h3>
		</div>
		<div class="container_dati_generali">
			<ng-template [ngIf]="message && message.koMessages && message.koMessages.length > 0">
				<ng-template ngFor let-item [ngForOf]="message?.koMessages"
					let-i="index"> <label>{{item}}</label></ng-template>
			</ng-template>
			<ng-template [ngIf]="!message || !message.koMessages || message.koMessages.length == 0">
				<label>Errore di comunicazione con il server. Riprovare pi&ugrave; tardi</label>
			</ng-template>
			
		</div>
	</div>
</div>